import { render } from "./result.vue?vue&type=template&id=dda44262&ts=true"
import script from "./result.vue?vue&type=script&lang=ts"
export * from "./result.vue?vue&type=script&lang=ts"

import "./result.vue?vue&type=style&index=0&id=dda44262&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__